import { Link } from 'react-router-dom';
import { manhuaList } from '@/mocks/manhua';

export default function HotRanking() {
  const topManhua = [...manhuaList]
    .sort((a, b) => b.views - a.views)
    .slice(0, 8);

  return (
    <section className="bg-foreground-950 py-14 md:py-20">
      <div className="px-4 md:px-8 lg:px-16">
        <div className="flex items-center gap-6 mb-10">
          <span className="inline-block px-4 py-1.5 border border-background-50/30 text-background-50 text-xs font-medium rounded-full whitespace-nowrap">
            热门排行
          </span>
          <h2 className="text-2xl md:text-4xl font-bold text-background-50 font-heading">
            人气韩漫推荐
          </h2>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide">
          {topManhua.map((manhua, idx) => (
            <Link
              key={manhua.id}
              to={`/manhua/${manhua.id}`}
              className="flex-shrink-0 w-[200px] md:w-[220px] group"
            >
              <div className="aspect-[3/4] rounded-lg overflow-hidden bg-background-100">
                <img
                  src={manhua.cover}
                  alt={manhua.altText}
                  title={manhua.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  loading="lazy"
                />
              </div>
              <div className="mt-3">
                <div className="flex items-center gap-2">
                  <span className="text-xs font-bold text-primary-500 whitespace-nowrap">TOP {idx + 1}</span>
                  <h3 className="text-sm font-medium text-background-50 truncate">{manhua.title}</h3>
                </div>
                <p className="text-xs text-foreground-400 mt-1 whitespace-nowrap">
                  {manhua.latestChapter}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}